import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8201804e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=8201804e&prod&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=8201804e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8201804e",
  null
  
)

export default component.exports